<label class="container" [ngClass]="theme">
  <input type="checkbox" (change)="onChange($event)" [attr.checked]="value || undefined" />
  <span class="slider round"></span>
</label>
